var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAllSites = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1760_35545)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 9C1.5 4.86001 4.85999 1.5 9 1.5C13.14 1.5 16.5 4.86001 16.5 9C16.5 13.14 13.14 16.5 9 16.5C4.85999 16.5 1.5 13.14 1.5 9ZM9 15C5.69247 15 3 12.3075 3 9C3 5.6925 5.69247 3 9 3C12.3075 3 15 5.6925 15 9C15 12.3075 12.3075 15 9 15Z",
  fill: "#CCE3F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.4181 10.4199C9.80511 11.0329 9.32606 11.7549 9 12.5404C8.67393 11.7549 8.19488 11.0329 7.58192 10.4199C6.96808 9.80611 6.24476 9.32641 5.45763 9C6.24476 8.67359 6.96808 8.19389 7.58192 7.58005C8.19488 6.96709 8.67393 6.24512 9 5.45957C9.32606 6.24512 9.80511 6.96709 10.4181 7.58005C11.0319 8.19389 11.7552 8.67359 12.5424 9C11.7552 9.32641 11.0319 9.80611 10.4181 10.4199Z",
  fill: "#CCE3F0",
  stroke: "#CCE3F0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1760_35545"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white"
})))));
export default SvgIconAllSites;